import { useCallback, useEffect, useState } from 'react'

import {
  deleteMaterial,
  listMaterials,
  saveMaterial,
  type MaterialCategory,
  type MaterialRecord,
} from '../lib/materialDb'

type MaterialsState =
  | { status: 'loading'; records: readonly MaterialRecord[]; error: null }
  | { status: 'ready'; records: readonly MaterialRecord[]; error: null }
  | { status: 'error'; records: readonly MaterialRecord[]; error: string }

export function useMaterials() {
  const [state, setState] = useState<MaterialsState>({
    status: 'loading',
    records: [],
    error: null,
  })

  const refresh = useCallback(async () => {
    setState((currentState) => ({
      status: 'loading',
      records: currentState.records,
      error: null,
    }))
    try {
      const records = await listMaterials()
      setState({ status: 'ready', records, error: null })
    } catch (error) {
      setState({
        status: 'error',
        records: [],
        error: error instanceof Error ? error.message : '资料读取失败',
      })
    }
  }, [])

  useEffect(() => {
    void refresh()
  }, [refresh])

  const add = useCallback(
    async (file: File, category: MaterialCategory) => {
      await saveMaterial(file, category)
      await refresh()
    },
    [refresh],
  )

  const remove = useCallback(
    async (materialId: string) => {
      await deleteMaterial(materialId)
      await refresh()
    },
    [refresh],
  )

  return {
    ...state,
    add,
    remove,
    refresh,
  }
}
